/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stay_SovereignInputs */

const en_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay Sovereign.`)
};

const es_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantente soberano.`)
};

const fr_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restez souverain.`)
};

const de_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleibe souverän.`)
};

const ja_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独立を維持する (Stay Sovereign)。`)
};

const zh_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保持自主可控 (Stay Sovereign)。`)
};

const ar_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابق مستقلاً.`)
};

const id_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetap Sovereign.`)
};

const it_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resta Indipendente.`)
};

const ru_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставайтесь Суверенными.`)
};

const pt_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha-se Sovereign.`)
};

const ko_stay_sovereign = /** @type {(inputs: Stay_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`당신만의 독립성을 유지하세요.`)
};

/**
* | output |
* | --- |
* | "Stay Sovereign." |
*
* @param {Stay_SovereignInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const stay_sovereign = /** @type {((inputs?: Stay_SovereignInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stay_SovereignInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stay_sovereign(inputs)
	if (locale === "es") return es_stay_sovereign(inputs)
	if (locale === "fr") return fr_stay_sovereign(inputs)
	if (locale === "de") return de_stay_sovereign(inputs)
	if (locale === "ja") return ja_stay_sovereign(inputs)
	if (locale === "zh") return zh_stay_sovereign(inputs)
	if (locale === "ar") return ar_stay_sovereign(inputs)
	if (locale === "id") return id_stay_sovereign(inputs)
	if (locale === "it") return it_stay_sovereign(inputs)
	if (locale === "ru") return ru_stay_sovereign(inputs)
	if (locale === "pt") return pt_stay_sovereign(inputs)
	return ko_stay_sovereign(inputs)
});